<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.account_carriersetting"
        :primary-fields="[ 'carrier', 'charge_account', 'edi_sysid' ]"
        @sort="sort = $event; $refs['carrierSettingsTable'].loadTable()"
        @apply="$refs['carrierSettingsTable'].loadTable()"
        @ready="$refs['carrierSettingsTable'].loadTable()"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        shadow="never"
      >
        <CarrierSettingsTable
          ref="carrierSettingsTable"
          :filters="filters"
          :sort="sort"
          :account-id="accountId"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import CarrierSettingsTable from '@/components/Application/Manage/Account/CarrierSettingsTable'

export default {
  components: {
    Filters,
    CarrierSettingsTable
  },
  data () {
    return {
      accountId: this.$route.params.accountId,
      breadcrumb: {
        name: 'Carrier Settings',
        route: { name: 'manage-accounts-account-configurations-carriers', params: { accountId: this.$route.params.accountId } }
      },
      actions: [],
      filters: [],
      sort: { field: 'uuid', direction: 'asc' }
    }
  },
  mounted () {
    this.actions = this.$refs.carrierSettingsTable.actions
  }
}
</script>

<style>

</style>
